/**
 * Tenant agent builder route — thin wrapper around <AgentBuilder scope="tenant">.
 *
 * Phase 4 of PR-A AgentBuilder shared-component refactor (2026-05-11).
 * The entire builder body lives in
 * `@/components/agent-builder-shared/AgentBuilder.tsx`. This file only
 * declares the TanStack-Router file route + parses the `?model=` query
 * param. ALL canvas, conversation, save, and mutation logic is shared
 * with the sysadmin builder route.
 */
import { createFileRoute } from '@tanstack/react-router';
import { AgentBuilder } from '@/components/agent-builder-shared/AgentBuilder';

// `?model=<brandId>` pre-selects the Argus brand for the new agent —
// driven by the "Use" action on Studio → Models so the catalog → assembly
// flow stays inside Argus, not Ask Argus (Codex audit F-S21 / #21).
export const Route = createFileRoute('/agents/builder')({
  validateSearch: (search: Record<string, unknown>) => ({
    model: typeof search.model === 'string' ? search.model : undefined,
    // "Edit with AI" deep-links here with the agent to preload (agents#7).
    editAgentId: typeof search.editAgentId === 'string' ? search.editAgentId : undefined,
  }),
  component: AgentBuilderRoute,
});

function AgentBuilderRoute() {
  const { model: preselectModel } = Route.useSearch();
  return <AgentBuilder scope="tenant" preselectModel={preselectModel} />;
}
